import React from "react";
import { useRecordContext } from "react-admin";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";

const circleStyle = {
  display: "flex",
  width: 10,
  height: 10,
  borderRadius: "50%",
};
export const OnlineField = ({ label = "" }) => {
  const record = useRecordContext();

  if (record.online) {
    return <div style={{ ...circleStyle, backgroundColor: "#42CB82" }} />;
  } else if (record.online === false) {
    return (
      <Tooltip
        title={
          <p
            style={{
              fontSize: "1.2em",
            }}
          >
            Last Online: {moment(record.lastSeen).format("llll")}
          </p>
        }
      >
        <div style={{ ...circleStyle, backgroundColor: "#EDE7ED" }} />
      </Tooltip>
    );
  } else {
    return null;
  }
};
